import React, { useState } from 'react';
import { GlobalStyle } from './GlobalStyle';

import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';

import Promotions from './screens/promotions';
import Events from './screens/events';
import EventsDemo from './screens/events-demo';
import Membership from './screens/membership';
import Tickets from './screens/tickets';
import Elevator from './screens/elevator';
import Exhibitions from './screens/exhibitions';
import useInterval from './hooks/useInterval';
import moment from 'moment';
import { getSlugFromPath, noCacheReq } from './utilities';

import './data/fonts/fonts.css';

const reset_url = 'https://api.asianart.org/wp-json/aam/1.0.0/digital-signage/reset';
const transform_url = 'https://api.asianart.org/wp-json/aam/1.0.0/digital-signage/transform';

export default function App() {

    let last_load = Date.now();

    const [transform, setTransform] = useState( 'none' );

    useInterval( () => {
        if( moment(last_load).fromNow() === 'a day ago' ) {
            window.location.reload();
        }
    }, 60000 * 60 );

    useInterval( () => {
        const path = window.location.pathname;
        let slug = getSlugFromPath(path);
        if( path === '/elevator-1' || path === '/elevator-2' || path === '/elevator-3' ) {
            const num = path.substr( path.length - 1, 1);
            slug = `${slug}-${num}`;
        }
        noCacheReq(reset_url,{
            sign: slug
        }).then( reset => {
            if( reset === 1 ) {
                window.location.reload();
            }
        } )
    }, 1000 * 10 );

    const path = window.location.pathname;
    const slug = getSlugFromPath(path);
    noCacheReq(transform_url,{
        sign: slug
    }).then( transform => {
        setTransform( transform );
    } );

    // if( window.location.pathname !== '/events' ) {
    //     window.location.href = 'http://aam-digital-signage.herokuapp.com/events';
    // }

    console.log('update test');

    return (
        <Router>
            <Switch>
                <Route path="/promotions">
                    <Promotions />
                </Route>
                <Route path="/events">
                    <Events />
                </Route>
                <Route path="/events-demo">
                    <EventsDemo />
                </Route>
                <Route path="/membership">
                    <Membership />
                </Route>
                <Route path="/tickets">
                    <Tickets />
                </Route>
                <Route path="/elevator-1">
                    <Elevator />
                </Route>
                <Route path="/elevator-2">
                    <Elevator />
                </Route>
                <Route path="/elevator-3">
                    <Elevator />
                </Route>
                <Route path="/exhibitions">
                    <Exhibitions />
                </Route>
            </Switch>
            <GlobalStyle transform={transform} />
        </Router>
    );
}
